<div style="text-align: center; min-width: 300px">
  <div mat-dialog-content>
    <lemon-dialog-header> Aseta asiakas työkieltoon </lemon-dialog-header>
    <div style="margin-top: 1rem; margin-bottom: 1rem">Asiakkaan yhteyshenkilöille ja kirjanpitäjälle lähetetään sähköposti, jossa kerrotaan työkieltoon asettamisesta. Työkiellon aikana kirjanpitäjän palvelut eivät ole käytettävissä. Työkielto päättyy kun erääntyneet laskut on maksettu.</div>
  </div>

  <div mat-dialog-actions style="padding-left: 0; padding-right: 0; gap: 0.25rem">
    <app-primary-button actionId="Peruuta ja sulje dialog" [focusRegionStart]="true" mat-dialog-close>Peruuta</app-primary-button>
    <app-secondary-button (click)="tallenna()" actionId="Aseta työkieltoon">Aseta työkieltoon</app-secondary-button>
  </div>
</div>
